import type { ListFilterFieldDef, ListFilterValues } from '../../types'

export function buildListFiltersSearchParams(
  current: URLSearchParams,
  fields: readonly ListFilterFieldDef[],
  values: ListFilterValues
): URLSearchParams {
  return fields.reduce((params, field) => {
    const next = new URLSearchParams(params)
    const value = (values[field.key] ?? '').trim()
    if (value) {
      next.set(field.key, value)
      return next
    }
    next.delete(field.key)
    return next
  }, new URLSearchParams(current))
}
